import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";

import Loader from "./components/loader";
import { NotFoundPage } from "./components/not-found-page";
import { routeTree } from "./routeTree.gen";
import { createQueryClient, orpc } from "./utils/orpc";

export const getRouter = () => {
  const queryClient = createQueryClient(() => {
    // only the customer panel needs a session; public pages never get UNAUTHORIZED
    const { pathname, href } = router.state.location;
    if (!pathname.startsWith("/panel")) return;
    queryClient.clear();
    void router.navigate({ to: "/login", search: { redirect: href } });
  });

  const router = createTanStackRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    context: { orpc, queryClient },
    defaultPendingComponent: () => <Loader />,
    // every unknown address gets the full-page Persian 404 (not nested in the panel shell)
    notFoundMode: "root",
    defaultNotFoundComponent: () => <NotFoundPage />,
  });

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  });

  return router;
};

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
